<template>
    <div class="tabs__list">
        <ul class="nav__side__bar">
        <li>
            <router-link active-class="active" :to="{name: 'AccountDetails'}">
                Account Details
            </router-link>
        </li>
        <li>
            <router-link active-class="active" :to="{name: 'AccountOrders'}">
            Orders
            </router-link>
        </li>
        <li>
            <router-link active-class="active" :to="{name: 'AccountSaved'}">
                Saved Machines
            </router-link>
        </li>
      </ul>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.tabs__list{
    display: flex;
    flex-direction: column;
    gap: 3px;
    max-width: 436px;
    width: 436px;
}
.nav__side__bar{
    width: max-content;
}
.nav__side__bar li{
    height: 32px;
}
.nav__side__bar a{
    display: flex;
    align-items: center;
    height: 32px;
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    width: 100%;
    padding: 0 16px;
}
.nav__side__bar .active{
    border-radius: 4px;
    background: rgb(222, 230, 234);
}
@media (max-width: 1024px) {
    .tabs__list{
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100%;
        flex-direction: row;
        max-width: unset;
        border-top: 1px solid rgb(222, 230, 234);
        background: white;
        z-index: 10;

    }
    .nav__side__bar{
        width: 100%;
        flex-direction: row;
        display: flex;
    }
    .nav__side__bar li{
        width: 100%;
        height: 50px;
    }
    .nav__side__bar a{
        height: 50px;
        justify-content: center;
        text-wrap: nowrap;
    }
}
</style>